import blockLastSendersHelper from './helpers/blockLastSendersHelper';
import showNotificationOnBlockSenders from './helpers/showNotificationOnBlockSenders';
import { getLastSenderMailboxesFromRowKeys } from './helpers/getMailboxes';
import { TableView } from 'owa-mail-list-store';
import { ActionSource } from 'owa-mail-store';
import { trace } from 'owa-trace';
import { logUsage } from 'owa-analytics';

/**
 * Block the smtp addresses from given rows
 * @param rowKeys the row keys
 * @param tableView the table view
 * @param actionSource the action source that triggers the block action
 */
export default function blockLastSendersFromTable(
    rowKeys: string[],
    tableView: TableView,
    actionSource: ActionSource
) {
    if (!rowKeys || rowKeys.length == 0) {
        trace.error(
            'Block button should not be exposed when there is nothing selected in list view.'
        );
        return;
    }

    logUsage('TnS_BlockSendersFromReadingPane', [actionSource]);

    // Get de-duped mailboxes
    const mailboxes = getLastSenderMailboxesFromRowKeys(rowKeys, tableView);
    blockLastSendersHelper(mailboxes, () => {
        showNotificationOnBlockSenders(mailboxes.length);
    });
}
